import dynaForms from '@elab/core/utils/dynaForms';

const getSelectors = storeName => {
    const dynaSelectors = dynaForms.getSelectors(storeName);
    const getDateOfBirth = state => dynaSelectors.getData(state).dateOfBirth || {};
    const getDialogConstraints = state => getDateOfBirth(state).dialogConstraints || [];
    const getAgeVerification = state =>
        getDialogConstraints(state).find(
            dialogConstraint => dialogConstraint.type === 'ageVerification',
        ) || {};
    const getPersonalInformationForm = state => dynaSelectors.getStore(state) || {};
    const getSavedDateOfBirthValue = state =>
        getPersonalInformationForm(state).savedDateOfBirthValue;
    const getShouldPrefill = state => getPersonalInformationForm(state).shouldPrefill;
    const getShouldPhonePrefill = state =>
        getPersonalInformationForm(state).shouldSkipPhonePrefill || false;
    const getMobileNumber = state => dynaSelectors.getData(state).mobileNumber || {};
    const _getPersonalData = state => getPersonalInformationForm(state).data || {};
    const getOrderSelected = state =>
        _getPersonalData(state).orderNumber ? _getPersonalData(state).orderNumber.value : '';
    const getPreservePhoneNumberPattern = state =>
        getPersonalInformationForm(state).preservePhoneNumberPattern || false;
    return {
        ...dynaSelectors,
        getAgeVerification,
        getSavedDateOfBirthValue,
        getShouldPrefill,
        getShouldPhonePrefill,
        getMobileNumber,
        getOrderSelected,
        getPreservePhoneNumberPattern,
    };
};

export default getSelectors;
